<template>
  <v-card max-width="400px" class="mx-auto">
    <v-card-text>
      <h3 v-text="$t('auth.register.businessOrPrivate')"></h3>
      <p v-text="$t('auth.register.businessOrPrivateHint')"></p>
    </v-card-text>
    <v-card-actions>
      <v-btn width="50%" color="accent" v-for="option of options" @click="update(option)">
        {{$t(option.text)}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'PromptIndividualOrBusiness',
  props: {
    options: {}
  },
  emits:['update'],
  methods:{
    update(option){
      this.$emit('update', option)
    }
  }
}
</script>